import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTone } from '../contexts/ToneContext';
import './BottomNavigation.css';

const BottomNavigation = ({ onAddTransaction }) => {
  const { t } = useTone();
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="bottom-navigation">
      <Link to="/dashboard" className={`nav-item ${isActive('/dashboard')}`}>
        <span className="nav-icon">📊</span>
        <span className="nav-label">{t('nav.home')}</span>
      </Link>

      <Link to="/transactions" className={`nav-item ${isActive('/transactions')}`}>
        <span className="nav-icon">💰</span>
        <span className="nav-label">{t('transactions.title')}</span>
      </Link>

      {/* FAB - Floating Action Button */}
      <button className="nav-item fab" onClick={onAddTransaction} aria-label="Add Transaction">
        <span className="fab-icon">+</span>
      </button>

      <Link to="/reports" className={`nav-item ${isActive('/reports')}`}>
        <span className="nav-icon">📈</span>
        <span className="nav-label">{t('reports.title')}</span>
      </Link>

      <Link to="/reminders" className={`nav-item ${isActive('/reminders')}`}>
        <span className="nav-icon">🔔</span>
        <span className="nav-label">{t('reminders.title')}</span>
      </Link>
    </nav>
  );
};

export default BottomNavigation;
